import { ConfigStateService, CoreModule } from '@abp/ng.core';
import * as i0 from '@angular/core';
import { APP_INITIALIZER, inject, makeEnvironmentProviders, NgModule } from '@angular/core';
import { AccountSettingsComponent, TimeZoneSettingComponent, AccountSettingsModule } from '@volo/abp.ng.account/admin';
import { SettingTabsService } from '@abp/ng.setting-management/config';
import { firstValueFrom, filter } from 'rxjs';

const ACCOUNT_SETTING_TAB_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: configureSettingTabs,
        deps: [SettingTabsService],
        multi: true,
    },
];
function configureSettingTabs(settingtabs) {
    const configState = inject(ConfigStateService);
    const tabsArray = [
        {
            name: "AbpAccount::Menu:Account" /* eAccountSettingTabNames.Account */,
            order: 100,
            requiredPolicy: 'AbpAccount.SettingManagement',
            component: AccountSettingsComponent,
        },
    ];
    return async () => {
        const kind = await firstValueFrom(configState.getDeep$('clock.kind').pipe(filter(val => val)));
        if (kind === 'Utc') {
            tabsArray.push({
                name: "AbpSettingManagement::Menu:TimeZone" /* eAccountSettingTabNames.TimeZone */,
                order: 100,
                requiredPolicy: 'SettingManagement.TimeZone',
                component: TimeZoneSettingComponent,
            });
        }
        settingtabs.add(tabsArray);
    };
}

function provideAccountAdminConfig() {
    return makeEnvironmentProviders([ACCOUNT_SETTING_TAB_PROVIDERS]);
}

class AccountAdminConfigModule {
    /**
     * @deprecated forRoot method is deprecated, use `provideAccountAdminConfig` *function* for config settings.
     */
    static forRoot() {
        return {
            ngModule: AccountAdminConfigModule,
            providers: [provideAccountAdminConfig()],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountAdminConfigModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.5", ngImport: i0, type: AccountAdminConfigModule, imports: [CoreModule, AccountSettingsModule], exports: [AccountSettingsModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountAdminConfigModule, imports: [CoreModule, AccountSettingsModule, AccountSettingsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: AccountAdminConfigModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CoreModule, AccountSettingsModule],
                    exports: [AccountSettingsModule],
                    declarations: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ACCOUNT_SETTING_TAB_PROVIDERS, AccountAdminConfigModule, configureSettingTabs, provideAccountAdminConfig };
